(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("matomo-ts", [], factory);
	else if(typeof exports === 'object')
		exports["matomo-ts"] = factory();
	else
		root["matomo-ts"] = factory();
})(this, function() {
return /******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
/******/ 		}
/******/ 	};
/******/
/******/ 	// define __esModule on exports
/******/ 	__webpack_require__.r = function(exports) {
/******/ 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
/******/ 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
/******/ 		}
/******/ 		Object.defineProperty(exports, '__esModule', { value: true });
/******/ 	};
/******/
/******/ 	// create a fake namespace object
/******/ 	// mode & 1: value is a module id, require it
/******/ 	// mode & 2: merge all properties of value into the ns
/******/ 	// mode & 4: return value when already ns object
/******/ 	// mode & 8|1: behave like require
/******/ 	__webpack_require__.t = function(value, mode) {
/******/ 		if(mode & 1) value = __webpack_require__(value);
/******/ 		if(mode & 8) return value;
/******/ 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
/******/ 		var ns = Object.create(null);
/******/ 		__webpack_require__.r(ns);
/******/ 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
/******/ 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
/******/ 		return ns;
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 0);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(1);


/***/ }),
/* 1 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var ABTest_1 = __webpack_require__(2);
exports.ABTest = ABTest_1.default;
var Variation_1 = __webpack_require__(3);
exports.Variation = Variation_1.default;
var Matomo = /** @class */ (function () {
    function Matomo() {
        this.previousUri = null;
        this.previousTitle = null;
    }
    Matomo.default = function () {
        if (!Matomo.instance) {
            Matomo.instance = new Matomo();
        }
        return Matomo.instance;
    };
    /**
     * Try to call the init method as soon as possible in the project
     */
    Matomo.prototype.init = function (trackerUrl, siteId, _a) {
        var _this = this;
        var _b = _a === void 0 ? {} : _a, domains = _b.domains, cookieDomain = _b.cookieDomain, _c = _b.crossDomainLinking, crossDomainLinking = _c === void 0 ? true : _c, _d = _b.async, async = _d === void 0 ? true : _d, _e = _b.srcUri, srcUri = _e === void 0 ? '/lib/piwik.js' : _e;
        if (window) {
            window._paq = window._paq || [];
            if (cookieDomain) {
                this.push(['setCookieDomain', cookieDomain]);
            }
            if (domains) {
                this.push(['setDomains', domains]);
            }
            if (crossDomainLinking) {
                this.push(['enableCrossDomainLinking']);
            }
            this.push(['enableHeartBeatTimer']);
            (function () {
                _this.push(['setTrackerUrl', "" + trackerUrl + (trackerUrl.endsWith('/') ? '' : '/') + "piwik.php"]);
                _this.push(['setSiteId', siteId]);
                var d = window.document;
                var g = d.createElement('script');
                var s = d.getElementsByTagName('script')[0];
                g.type = 'text/javascript';
                if (async) {
                    g.async = true;
                    g.defer = true;
                }
                g.src = srcUri;
                s.parentNode.insertBefore(g, s);
            })();
        }
        else {
            throw new Error("Window context is undefined, make sure you're calling this in a web-browser aware environment.");
        }
    };
    Matomo.prototype.push = function (args) {
        window._paq.push(args);
    };
    Matomo.prototype.setUserId = function (userId) {
        this.push(['setUserId', userId]);
    };
    Matomo.prototype.resetUserId = function () {
        this.push(['resetUserId']);
    };
    Matomo.prototype.setReferrerUrl = function (referrerUrl) {
        this.push(['setReferrerUrl', referrerUrl]);
    };
    /**
     * If the last tracked uri and name are identical the page will not be tracked
     * This prevent multiple calls when using a components based frameworks
     * where the lifecycle tend to refresh the DOM very often
     */
    Matomo.prototype.trackPageView = function (name) {
        var uri = window.document.documentURI;
        var title = name ? name : window.document.title;
        if (uri === this.previousUri && title === this.previousTitle) {
            // Safety to not log multiple times the same pageview
            // Useful w/ React-like framework
            return;
        }
        this.push(['setCustomUrl', uri]);
        this.push(['setDocumentTitle', window.document.domain + '/' + title]);
        if (this.previousUri) {
            this.push(['setGenerationTimeMs', 0]);
        }
        this.push(['trackPageView']);
        this.previousUri = uri;
        this.previousTitle = title;
    };
    /**
     * If you are looking after outlinks tracking this method should be called after every DOM updates.
     */
    Matomo.prototype.trackLinks = function () {
        this.push(['enableLinkTracking']);
    };
    Matomo.prototype.trackEvent = function (category, action, opt) {
        var event = ['trackEvent', category, action];
        if (opt) {
            if (opt.name) {
                event.push(opt.name);
            }
            if (opt.value) {
                if (!opt.name) {
                    event.push('');
                }
                event.push(opt.value);
            }
        }
        this.push(event);
    };
    Matomo.prototype.trackEcommerceOrder = function (orderId, grandTotal) {
        var event = ['trackEcommerceOrder', orderId, grandTotal];
        this.push(event);
    };
    Matomo.prototype.trackABTest = function (abTest) {
        abTest.start(this);
    };
    return Matomo;
}());
exports.default = Matomo;


/***/ }),
/* 2 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var ABTest = /** @class */ (function () {
    function ABTest(name) {
        this.includedTargets = [];
        this.excludedTargets = [];
        this.percentage = 100;
        this.variations = [];
        this.name = name;
    }
    ABTest.prototype.setPercentage = function (percentage) {
        this.percentage = percentage;
        return this;
    };
    ABTest.prototype.setStartTime = function (startDateTime) {
        this.startDateTime = startDateTime;
        return this;
    };
    ABTest.prototype.setEndTime = function (endDateTime) {
        this.endDateTime = endDateTime;
        return this;
    };
    ABTest.prototype.setTrigger = function (trigger) {
        this.trigger = trigger;
        return this;
    };
    ABTest.prototype.addIncludedTarget = function (includedTarget) {
        this.includedTargets.push(includedTarget);
        return this;
    };
    ABTest.prototype.addExludedTarget = function (excludedTarget) {
        this.excludedTargets.push(excludedTarget);
        return this;
    };
    ABTest.prototype.addVariation = function (variation) {
        this.variations.push(variation);
        return this;
    };
    ABTest.prototype.start = function (matomo) {
        if (this.variations.length < 1) {
            throw new Error('There is no variation ');
        }
        matomo.push(['AbTesting::create', this]);
    };
    return ABTest;
}());
exports.default = ABTest;


/***/ }),
/* 3 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var Variation = /** @class */ (function () {
    function Variation(name) {
        this.name = name;
        this.activate = function () { return null; };
    }
    Variation.prototype.setPercentage = function (percentage) {
        this.percentage = percentage;
        return this;
    };
    Variation.prototype.setActivate = function (activate) {
        this.activate = activate;
        return this;
    };
    return Variation;
}());
exports.default = Variation;


/***/ })
/******/ ]);
});
//# sourceMappingURL=matomo-ts.js.map